/** Ensures that internally, pathname values can be compared properly */
export const normalizePathname = (pathname: string): string =>
  pathname.toLowerCase().replace(/^(\/.*?)\/+$/, '$1') || '/';
